export default "__VITE_ASSET__CrsI469P__"